import getWindowUrl from './getWindowUrl.mjs';

// eslint-disable-next-line @stylistic/max-len
const PREFIX_REGEX = /^https?:\/\/((qa|local|review-[^.]*-(pwa|templates|dashboard))(\.|-))?(([^/]+\.ch)(:\d+)?(\/(fashion-jobs|lavorare-nella-moda))|([^/]+\.(be|ca))(:\d+)?(\/fr)|([^/]+\.[^/]\w+)(:\d+)?)/;

const getPrefix = (requestUrl) => {
  const url = requestUrl || getWindowUrl();
  const match = url.match(PREFIX_REGEX) || [];
  const host = match[14] || match[10] || match[6] || 'fashionunited.ie';
  const languagePrefix = match[13] || match[8];
  return `${host}${languagePrefix || ''}`;
};

export default getPrefix;
